import React from 'react';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { PerformanceSummary } from '../../../PerformanceSummary/PerformanceSummary';

interface Props {
  title: string;
}

export const ActivitySummaryCard = React.memo(({ title }: Props) => {
  return (
    <Card p="16" display="flex" flexDirection="column">
      <Text variant="cardTitle" mb="24">
        {title}
      </Text>

      <Box display="flex" flexDirection="column" flex={1}>
        <PerformanceSummary isTransactions />
      </Box>
    </Card>
  );
});
